export default __webpack_public_path__ + "static/media/element_spec_31.31c6b9bc.webp";